/**
 * Get understandable error messages from the API
 * @param error
 * @returns {*[]}
 */
export function getErrorMessage(error) {
  const errors = [];
  if (!error?.response?.data?.errors) {
    if (error?.response?.data?.message) {
      errors.push(error?.response?.data?.message);
    } else {
      errors.push(error?.message);
    }
  } else {
    Object.keys(error?.response?.data?.errors).forEach((errorItem) => {
      errors.push(error?.response?.data?.errors[errorItem][0]);
    });
  }
  return errors;
}
